<template>
  <h1 class="text-white text-center font-bold p-4 border-b">
    پیام های من
  </h1>
  <div class="mb-4 p-4" v-if="notifications.length > 0">
    <div class="rounded-xl p-4 bg-gray-900 my-4"
         v-for="notification in notifications"
         :key="notification.signaL_ID"
         @touchstart="toggleAnimation($event)"
         @touchend="toggleAnimation($event)">
      <div class="flex justify-between items-center" @click="setSeen(notification.signaL_ID)">
        <div class="flex text-sm">
          <ClockIcon class="h-5 w-5 text-yellow-300"/>
          <span class="mr-1 text-white">{{ notification.signaL_TIME + " " + notification.signaL_DATE }}</span>
        </div>
        <CheckIcon class="w-5 h-w text-green-500" v-if="notification.signaL_ISREAD === 1"/>
      </div>
      <span class="mr-1 text-white text-xs">{{ notification.signaL_MESSAGE }}</span>
    </div>
  </div>
</template>

<script>
import {getNotificationList, setNotificationAsRead} from "../API/API";
import {CheckIcon, ClockIcon} from "@heroicons/vue/outline";

export default {
  name: "NotificationInbox",
  components: {ClockIcon, CheckIcon},
  data() {
    return {
      notifications: []
    }
  },
  async created() {
    this.notifications = (await getNotificationList()).data.result
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('border-yellow-500')
      event.currentTarget.classList.toggle('border')
    },
    async setSeen(id) {
      setNotificationAsRead(id)
      .then(async () => {
        this.notifications = (await getNotificationList()).data.result
      })
    }
  }
}
</script>

<style scoped>

</style>